'use strict';

var joinSchemeLogin = require('./joinSchemeLogin');

var totalSteps = $('.scheme-form-step').length;
var currentStep = 1;

/**
 * step count colour tracker
 * @param {*} step step count
 */
function showStep(step) {
    currentStep = step;
    $('.scheme-form-step').removeClass('active').hide();

    $('.scheme-form-step[data-step="' + step + '"]').fadeIn(200).addClass('active');

    $('.scheme-step')
        .removeClass('active completed');

    $('.scheme-step').each(function () {
        var stepNo = parseInt($(this).data('step'), 10);

        if (stepNo < step) {
            $(this).addClass('completed');
        } else if (stepNo === step) {
            $(this).addClass('active');
        }
    });
}

/**
 * to reset the form
 */
function resetSchemeForm() {
    currentStep = 1;
    var form = $('.scheme-registration-form')[0];
    if (form) {
        form.reset();
    }
    showStep(1);
}

/**
 * Checks if a given DOB string (dd.mm.yyyy) makes the person 18+ today
 * @param {string} dobValue - date string in dd.mm.yyyy format
 * @returns {boolean} true if age >= 18
 */
function isAgeValid(dobValue) {
    if (!dobValue) {
        return false;
    }

    var parts = dobValue.split('.');
    if (parts.length !== 3) {
        return false;
    }

    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1; // JS months are 0-indexed
    var year = parseInt(parts[2], 10);
    var dob = new Date(year, month, day);
    var today = new Date();
    var age = today.getFullYear() - dob.getFullYear();
    var monthDiff = today.getMonth() - dob.getMonth();
    var dayDiff = today.getDate() - dob.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age -= 1;
    }

    return age >= 18;
}

/**
 * Validate current step
 * @param {number} step Step number
 * @returns {boolean} validation status
 */
function validateStep(step) {
    var isValid = true;
    var $step = $('.scheme-form-step[data-step="' + step + '"]');
    $step.find('input, select, textarea').each(function () {
        var $field = $(this);
        if (!$field.is(':visible') || $field.is(':disabled')) {
            return;
        }
        if (!$field.prop('required')) {
            return;
        }
        var value = $.trim($field.val());
        if (!value) {
            isValid = false;
            $field.addClass('is-invalid');
        } else {
            $field.removeClass('is-invalid');
            $field.next('.invalid-feedback').remove();

            if ($field.hasClass('scheme-birthday') && !isAgeValid(value)) {
                isValid = false;
                $field.addClass('is-invalid');
                $field.next('.invalid-feedback').text('Age should be more than 18 years');
            }
        }
    });
    return isValid;
}

var calculatorMode = 'amount';
/**
 * Validates the DOB field for the 18+ rule and toggles error UI
 * @param {jQuery} $input - the dob input element
 * @returns {boolean} validation status
 */
function validateAgeField($input) {
    var value = $.trim($input.val());
    var $feedback = $input.siblings('.invalid-feedback');

    if (!value) {
        return true; // let the "required" check in validateStep handle empty case
    }

    if (!isAgeValid(value)) {
        $input.addClass('is-invalid');
        $feedback.text('Age should be more than 18 years');
        return false;
    }

    $input.removeClass('is-invalid');
    $feedback.text('Please select date of birth');
    return true;
}

$(document).on('keyup change', '.scheme-form-step input, .scheme-form-step select, .scheme-form-step textarea', function () {
    var $field = $(this);
    if ($field.hasClass('price-amount-input')) {
        return;
    }

    if ($field.hasClass('scheme-birthday')) {
        validateAgeField($field);
        return;
    }
    if ($.trim($field.val()) !== '') {
        $field.removeClass('is-invalid');
        $field.next('.invalid-feedback').remove();
    }
});

$(document).on('click', '.next-step', function (e) {
    e.preventDefault();
    if (!validateStep(currentStep)) {
        return;
    }
    // Only validate KYC on Step 2
    if (currentStep === 2) {
        var $activeKyc = $('.scheme-form-step[data-step="2"] .kyc-input.active input');
        var value = $.trim($activeKyc.val());
        var $error = $activeKyc.closest('.form-group').find('.invalid-feedback');
        var isValid = true;
        if ($activeKyc.hasClass('scheme-pan')) {
            var panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
            if (value === '') {
                isValid = false;
                $error.text('Please enter PAN number.');
            } else if (!panRegex.test(value)) {
                isValid = false;
                $error.text('Please enter a valid PAN number.');
            }
        } else if ($activeKyc.hasClass('scheme-aadhar')) {
            var aadharRegex = /^[2-9][0-9]{11}$/;
            if (value === '') {
                isValid = false;
                $error.text('Please enter Aadhaar number.');
            } else if (!aadharRegex.test(value)) {
                isValid = false;
                $error.text('Please enter a valid Aadhaar number.');
            }
        }

        if (!isValid) {
            $activeKyc.addClass('is-invalid');
            return;
        }

        $activeKyc.removeClass('is-invalid');
        $error.text('');
    }

    // Validate nominee details only on Proceed Calculator button
    if ($(this).hasClass('proceed-calculator')) {
        var validNominee = true;

        var $relation = $('#nominee-relation');
        var $nominee = $('#customer-nominee-name');

        // Nominee Relation
        if ($.trim($relation.val()) === '') {
            validNominee = false;
            $relation.addClass('is-invalid');

            if (!$relation.next('.invalid-feedback').length) {
                $relation.after('<div class="invalid-feedback">Please select nominee relationship.</div>');
            }
        } else {
            $relation.removeClass('is-invalid');
            $relation.next('.invalid-feedback').remove();
        }

        // Nominee Name
        if ($.trim($nominee.val()) === '') {
            validNominee = false;
            $nominee.addClass('is-invalid');
        } else {
            $nominee.removeClass('is-invalid');
        }

        if (!validNominee) {
            return;
        }
    }

    if (currentStep < totalSteps) {
        showStep(currentStep + 1);

        $('html, body').animate({
            scrollTop: 0
        }, 200);
    }
});

$(document).on('click', '.prev-step', function (e) {
    e.preventDefault();
    if (currentStep > 1) {
        showStep(currentStep - 1);
        $('html,body').animate({
            scrollTop: 0
        }, 200);
    }
});

resetSchemeForm();

/**
 * Update Calculation Result
 * @param {number} amount amount
 * @param {number} boardRate board rate
 */
function updateCalculation(amount, boardRate) {
    if (!boardRate || amount <= 0) {
        return;
    }

    var goldWeight = amount / boardRate;
    $('.c-amount-value').html('₹' + amount.toLocaleString('en-IN'));
    $('.c-weight-value').text(goldWeight.toFixed(5) + ' GMS');
    $('.c-total-value').html('₹' + amount.toLocaleString('en-IN'));
    $('.gold-price .value').html('₹' + boardRate.toLocaleString('en-IN'));
    $('.calculations .value').html(
        '₹' + amount.toLocaleString('en-IN')
        + ' ÷ ₹' + boardRate.toLocaleString('en-IN')
        + ' = <strong>' + goldWeight.toFixed(5) + ' GMS</strong>'
    );

    // Hidden fields
    $('.final-amount').val(amount.toFixed(2));
    $('.final-weight').val(goldWeight.toFixed(5));

    // Input right-side weight
    $('.calculated-weight').text(
        goldWeight.toFixed(5) + ' GMS'
    );
}

/**
 * @param {number} value Contains the amount value
 * @returns {number} returns round off amount value
 */
function roundAmount(value) {
    return Math.round(Number(value) || 0);
}

/**
 * Update Daily Scheme Calculation by Weight
 *
 * @param {number} weight Gold weight in grams
 */
function updateDailySchemeByWeight(weight) {
    var scheme = $.trim($('#customer-scheme-Name').val()).toUpperCase();
    var boardRate = scheme === 'DIGI SILVER'
        ? Number($('.silver-board-rate').val())
        : Number($('.gold-board-rate').val());
    var bonusPercentage = Number($('.bonus-percentage').val()) || 7;
    if (!boardRate || weight <= 0) {
        return;
    }

    var amount = weight * boardRate;
    var bonusAmount = (amount * bonusPercentage) / 100;
    var bonusWeight = bonusAmount / boardRate;
    var tax = 0;
    var total = amount + bonusAmount + tax;

    // Rounded amounts
    var roundedAmount = roundAmount(amount);
    var roundedBonusAmount = roundAmount(bonusAmount);
    var roundedTax = roundAmount(tax);
    var roundedTotal = roundAmount(total);

    // Right-side amount
    $('.calculated-weight').html(
        '₹ ' + roundedAmount.toLocaleString('en-IN')
    );

    // Summary
    $('.amount-price').html(
        '₹ ' + roundedAmount.toLocaleString('en-IN')
    );

    $('.bonus-label').text(
        'Bonus (' + bonusPercentage.toFixed(2) + '%):'
    );

    $('.bonus-price').html(
        '₹ ' + roundedBonusAmount.toLocaleString('en-IN')
    );

    $('.tax-price').html(
        '₹ ' + roundedTax.toLocaleString('en-IN')
    );

    $('.total-amount-price').html(
        '₹ ' + roundedTotal.toLocaleString('en-IN')
    );

    // Bonus earned - amount rounded, weight remains 5 decimals
    $('.bonus-earned .bonus span').html(
        '₹'
        + roundedBonusAmount.toLocaleString('en-IN')
        + ' ('
        + bonusWeight.toFixed(5)
        + ' GMS)'
    );

    // Hidden values
    $('.final-amount').val(roundedAmount);
    $('.final-weight').val(weight.toFixed(5));
    $('.bonus-amount').val(roundedBonusAmount);
    $('.bonus-weight').val(bonusWeight.toFixed(5));
}

/**
 * @param {number} amount weight amount calculations update
 */
function updateDailySchemeCalculation(amount) {
    var scheme = $('#customer-scheme-Name').val();
    var boardRate = scheme.toUpperCase() === 'DIGI SILVER'
        ? Number($('.silver-board-rate').val())
        : Number($('.gold-board-rate').val());

    var bonusPercentage = Number($('.bonus-percentage').val()) || 7;
    if (!boardRate || amount <= 0) {
        return;
    }

    var weight = amount / boardRate;
    var bonusAmount = (amount * bonusPercentage) / 100;
    var bonusWeight = bonusAmount / boardRate;
    var tax = 0;
    var total = amount + bonusAmount + tax;

    // Rounded amount values
    var roundedAmount = roundAmount(amount);
    var roundedBonusAmount = roundAmount(bonusAmount);
    var roundedTax = roundAmount(tax);
    var roundedTotal = roundAmount(total);

    // Right side input weight - keep 5 decimals
    $('.calculated-weight').text(
        weight.toFixed(5) + ' GMS'
    );

    // Amount
    $('.amount-price').html(
        '₹ ' + roundedAmount.toLocaleString('en-IN')
    );

    $('.bonus-label').text(
        'Bonus (' + bonusPercentage.toFixed(2) + '%):'
    );

    $('.bonus-price').html(
        '₹ ' + roundedBonusAmount.toLocaleString('en-IN')
    );

    // Tax
    $('.tax-price').html(
        '₹ ' + roundedTax.toLocaleString('en-IN')
    );

    $('.total-amount-price').html(
        '₹ ' + roundedTotal.toLocaleString('en-IN')
    );

    // Bonus earned
    $('.bonus-earned .bonus span').html(
        '₹'
        + roundedBonusAmount.toLocaleString('en-IN')
        + ' ('
        + bonusWeight.toFixed(5)
        + ' GMS)'
    );

    // Hidden values
    $('.final-amount').val(roundedAmount);
    $('.final-weight').val(weight.toFixed(5));
    $('.bonus-amount').val(roundedBonusAmount);
    $('.bonus-weight').val(bonusWeight.toFixed(5));
}

/**
 * Used to render the weight on checked inputs
 * @param {number} amount amount
 */
function renderWeightButtons() {
    var schemeName = $('#customer-scheme-Name').val().trim().toUpperCase();

    var values = schemeName === 'DIGI SILVER'
        ? [1, 3, 5, 7]
        : [0.1, 0.3, 0.5, 0.7];

    var html = '';

    values.forEach(function (item) {
        html += '<div class="price-amount">'
            + '<p class="price" data-weight="' + item + '">'
            + item + ' GMS'
            + '</p>'
            + '</div>';
    });

    $('.price-divs').html(html);
}

/**
 * Render Amount Buttons on change of field
 */
function renderAmountButtons() {
    var values = [100, 500, 1000, 1500, 2000];
    var html = '';
    values.forEach(function (item) {
        html
            += '<div class="price-amount">'
            + '<p class="price" data-price="' + item + '">'
            + '₹ ' + item
            + '</p>'
            + '</div>';
    });
    $('.price-divs').html(html);
}

$(document).on('change', 'input[name="calculatorMode"]', function () {
    calculatorMode = $(this).val();
    if (calculatorMode === 'amount') {
        $('.currency-symbol').text('₹');
        $('.calculated-weight').show();
        $('.price-amount-input').val(1500);
        renderAmountButtons();
        updateDailySchemeCalculation(1500);
    } else {
        $('.currency-symbol').text('GMS');
        $('.calculated-weight').text('');
        $('.price-amount-input').val('0.700');
        renderWeightButtons();
        updateDailySchemeByWeight(0.700);
    }
});

/**
 * validate amount of input
 * @param {number} value restrict amount
 * @returns {boolean} returns the flag for scheme name
 */
function validateAmountInput(value) {
    var schemeName = $('#customer-scheme-Name').val().trim().toUpperCase();
    var $input = $('.price-amount-input');
    var $error = $input.closest('.price-calc-input-field').find('.invalid-feedback');
    var $paymentBtn = $('.initiate-payment');
    var inputValue = $.trim(String(value));
    if (calculatorMode === 'amount') {
        if (!/^\d+$/.test(inputValue)) {
            $input.addClass('is-invalid');
            $error.text('Amount should be a whole number.').removeClass('d-none');
            $paymentBtn.prop('disabled', true);

            return false;
        }
    }

    if (calculatorMode === 'weight') {
        if (!/^\d+(\.\d{1,3})?$/.test(inputValue)) {
            $input.addClass('is-invalid');
            $error.text('Weight can have maximum 3 decimal places.').removeClass('d-none');
            $paymentBtn.prop('disabled', true);
            return false;
        }
    }

    var numericValue = Number(inputValue);
    var amount = numericValue;
    if (calculatorMode === 'weight') {
        var boardRate = schemeName === 'DIGI SILVER'
            ? Number($('.silver-board-rate').val())
            : Number($('.gold-board-rate').val());

        amount = numericValue * boardRate;
    }

    if (schemeName === 'DIGI GOLD' || schemeName === 'DIGI SILVER') {
        if (amount < 100) {
            $input.addClass('is-invalid');
            $error
                .text('Minimum amount should be ₹100.')
                .removeClass('d-none');
            $paymentBtn.prop('disabled', true);

            return false;
        }
    }

    if (schemeName === 'NEW SWARNA SUBHIKSHAM') {
        if (amount < 1000) {
            $input.addClass('is-invalid');
            $error
                .text('Minimum amount should be ₹1000.')
                .removeClass('d-none');
            $paymentBtn.prop('disabled', true);

            return false;
        }

        if (amount % 500 !== 0) {
            $input.addClass('is-invalid');
            $error
                .text('Amount should be in multiples of ₹500.')
                .removeClass('d-none');
            $paymentBtn.prop('disabled', true);

            return false;
        }
    }

    if (schemeName === 'SWARNA VIRUKSHAM') {
        if (amount < 25000) {
            $input.addClass('is-invalid');
            $error
                .text('Minimum amount should be ₹25000.')
                .removeClass('d-none');
            $paymentBtn.prop('disabled', true);

            return false;
        }

        if (amount % 500 !== 0) {
            $input.addClass('is-invalid');
            $error
                .text('Amount should be in multiples of ₹500.')
                .removeClass('d-none');
            $paymentBtn.prop('disabled', true);

            return false;
        }
    }

    $input.removeClass('is-invalid');
    $error
        .text('')
        .addClass('d-none');

    $paymentBtn.prop('disabled', false);

    return true;
}

$(document).on('input', '.price-amount-input', function () {
    var rawValue = $(this).val();
    if (!validateAmountInput(rawValue)) {
        return;
    }

    var value = Number(rawValue);

    if ($('.daily-scheme').length) {
        if (calculatorMode === 'amount') {
            updateDailySchemeCalculation(value);
        } else {
            updateDailySchemeByWeight(value);
        }
    } else {
        updateCalculation(
            value,
            Number($('.gold-board-rate').val())
        );
    }
});

$(document).on('blur', '.price-amount-input', function () {
    var value = $(this).val();

    validateAmountInput(value);
});

$(document).on('input', '.price-amount-input', function () {
    var value = Number($(this).val()) || 0;
    if (!validateAmountInput(value)) {
        return;
    }
    if ($('.daily-scheme').length) {
        if (calculatorMode === 'amount') {
            updateDailySchemeCalculation(value);
        } else {
            updateDailySchemeByWeight(value);
        }
    } else {
        updateCalculation(value, Number($('.gold-board-rate').val()));
    }
});

$(document).on('blur', '.price-amount-input', function () {
    var $this = $(this);
    var value = Number($this.val()) || 0;
    setTimeout(function () {
        validateAmountInput(value);
    }, 0);
});

/**
 * Calculate Board Result
 * @param {Object} response response
 */
function calculateBoard(response) {
    var amount = Number($('.price-amount-input').val()) || 0;
    if ($('.daily-scheme').length) {
        updateDailySchemeCalculation(amount);
        return;
    }

    var boardRate = Number(response.schemeDetails.boardRate22Kt);
    updateCalculation(amount, boardRate);
}

/**
 * Populate Scheme Details
 * @param {Object} response response from controller
 */
function populateSchemeDetails(response) {
    if (response.schemeDetails.schemeName.toUpperCase() === 'DIGI SILVER') {
        $('.rate').text(response.schemeDetails.silverRate);
    } else {
        $('.rate').text(response.schemeDetails.boardRate22Kt);
    }
    $('.update-date-time').text(
        response.schemeDetails.lastUpdatedDate
        + ' '
        + response.schemeDetails.lastUpdatedTime
    );
    $('.gold-board-rate').val(response.schemeDetails.boardRate22Kt);
    $('.silver-board-rate').val(response.schemeDetails.silverRate);
    $('#customer-scheme-Name').addClass('has-value').val(response.schemeDetails.schemeName);
    $('#customer-name').addClass('has-value').val(response.schemeDetails.fullName);
    $('#customer-mobileno').addClass('has-value').val(response.schemeDetails.mobile);
    $('#customer-email').addClass('has-value').val(response.schemeDetails.email);
    $('#customer-dob').addClass('has-value').val(response.schemeDetails.dob);
    $('#customer-pincode').addClass('has-value').val(response.schemeDetails.pincode);
    $('#customer-address').addClass('has-value').val(response.schemeDetails.address);
    $('#customer-city').addClass('has-value').val(response.schemeDetails.city);
    $('#customer-state').addClass('has-value').val(response.schemeDetails.state);
    $('.scheme-details').val(JSON.stringify(response.schemeDetails));
    calculateBoard(response);
}

$(document).on('click', '.price-amount', function () {
    $('.price-amount').removeClass('active');
    $(this).addClass('active');
    var value;
    if (calculatorMode === 'amount') {
        value = Number($(this).find('.price').data('price'));
        $('.price-amount-input').val(value);
        updateDailySchemeCalculation(value);
    } else {
        value = Number($(this).find('.price').data('weight'));
        $('.price-amount-input').val(value.toFixed(3));
        updateDailySchemeByWeight(value);
    }
});

$(document).on('submit', '.scheme-registration-form', function (e) {
    e.preventDefault();
    // Submit only on Step 3
    if (currentStep !== 3) {
        return;
    }
    var $form = $(this);
    var url = $form.data('url');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'POST',
        data: $form.serialize(),
        success: function (response) {
            if (joinSchemeLogin.isLoggedOutResponse(response)) {
                // Session expired: reloading the join form logs in again and continues
                window.location.reload();
                return;
            }
            if (!response.success) {
                return;
            }
            populateSchemeDetails(response);
            showStep(4);
            $('.scheme-type').val('NEW');
            $('#passbookNo').val('NEW');
        },
        error: function () {
        },
        complete: function () {
            $.spinner().stop();
        }
    });
});

$(document).on('click', '.kyc-card', function () {
    var target = $(this).data('target');
    $('.kyc-card').removeClass('active');
    $(this).addClass('active');
    $('.kyc-input').removeClass('active');
    $('.kyc-input[data-content="' + target + '"]')
        .addClass('active');
});

/**
 * Initializes date picker
 * @param {string} containers - Container selector
 */
function initializeDatePicker(containers) {
    containers.forEach(function (containerSelector) {
        var $container = $(containerSelector);
        var $input = $container.find('input');
        var $icon = $container.find('.calender-icon');
        var $datePickerWrapper = $container.find('.date-picker-wrapper');
        var orientation = $container.hasClass('birthday-container') ? 'auto bottom' : 'auto top';

        if (!$input.hasClass('datepicker-initialized')) {
            var existingVal = $input.val();
            var highlightToday;

            if ($input.val() === '') {
                highlightToday = true;
            } else {
                highlightToday = false;
            }

            $input.datepicker({
                language: 'en',
                format: 'dd.mm.yyyy',
                container: $datePickerWrapper,
                endDate: 'future',
                orientation: orientation,
                autoclose: true,
                todayHighlight: highlightToday
            }).addClass('datepicker-initialized').on('changeDate', function () {
                $input.parent().toggleClass('focus-active', true);
                var $picker = $input.data('datepicker').picker;
                $picker.find('.day.today').removeClass('today');
                $input.addClass('has-value');

                if ($input.hasClass('scheme-birthday')) {
                    validateAgeField($input);
                    $input.datepicker('hide');
                }
            });

            if (existingVal) {
                $input.datepicker('update', existingVal);
            }
        }
        $input.on('focus', function () {
            $input.datepicker('show');
        });

        $icon.on('click', function () {
            $input.focus();
        });
    });
}

$(document).on('click', '.quick-pay-scheme-select, .account-pay-now, .through-ledger-pay', function (e) {
    e.preventDefault();
    var $this = $(this);
    var existingTarget = {
        scheme: $this.data('scheme-name'),
        type: 'EXISTING',
        passbookNo: $this.data('passbook-no')
    };
    if (!joinSchemeLogin.isLoggedIn()) {
        joinSchemeLogin.loginAndContinue(existingTarget, $this.data('join-url'));
        return;
    }
    $.spinner().start();

    $.ajax({
        url: $this.data('url'),
        type: 'POST',
        data: {
            schemeName: $this.data('scheme-name'),
            schemeCode: $this.data('scheme-code'),
            passbookNo: $this.data('passbook-no'),
            dueAmount: $this.data('due-amount'),
            holdDays: $this.data('hold-days'),
            bonusPercentage: $this.data('bonus-percentage'),
            mobileNo: $('.quick-pay-mobile').val()
        },
        success: function (response) {
            $.spinner().stop();
            if (joinSchemeLogin.isLoggedOutResponse(response)) {
                joinSchemeLogin.loginAndContinue(existingTarget, $this.data('join-url'));
                return;
            }
            if (response.success) {
                window.open(response.redirectUrl, '_blank');
            }
        },
        error: function (xhr) {
            $.spinner().stop();
            joinSchemeLogin.handleAccessDenied(xhr);
        }
    });
});

$(document).on('change', '#nominee-relation', function () {
    if ($(this).val()) {
        $(this).removeClass('is-invalid');
        $(this).next('.invalid-feedback').remove();
    }
});

$(document).on('input', '#customer-nominee-name', function () {
    if ($.trim($(this).val())) {
        $(this).removeClass('is-invalid');
    }
});

/**
 * update the existing data
 * @param {Object} response contains scheme details
 */
function updateExistingDate(response) {
    var details = response.schemeDetails;
    $('.scheme-title').text(details.schemeName);
    $('.existing-scheme-name').text(details.schemeName);
    $('.existing-group-code').text(details.passbookNo);
    $('.existing-total-weight').text(details.totalWeight);
    $('.existing-total-amount').text(details.totalAmount);
}

/**
 * Update investment progress for existing scheme
 *
 * @param {Object} details existing scheme details
 */
function updateInvestmentProgress(details) {
    var holdingDays = Number(details.holdDays) || 0;
    var bonusPercentage = Number(details.bonusPercentage) || 0;
    $('.investment-bonus-percentage').text(bonusPercentage + '%');
    $('.investment-text').text(
        'This transaction will earn you a ' + bonusPercentage + '% benefit.'
    );
    $('.investment-day-text').text(
        'Day ' + holdingDays + ' of 300 Completed'
    );
    var $segments = $('.investment-progress .progress-segment');
    var $progressPercent = $('.investment-progress .progress-percent');
    $segments.removeClass('active');
    $progressPercent.removeClass('active').text('');
    var activeIndex = -1;
    if (holdingDays >= 1 && holdingDays <= 75) {
        activeIndex = 0;
    } else if (holdingDays > 75 && holdingDays <= 150) {
        activeIndex = 1;
    } else if (holdingDays > 150 && holdingDays <= 225) {
        activeIndex = 2;
    } else if (holdingDays > 225 && holdingDays <= 300) {
        activeIndex = 3;
    }

    if (activeIndex !== -1) {
        $segments.each(function (index) {
            if (index <= activeIndex) {
                $(this).addClass('active');
            }
        });

        // Show percentage only on current stage
        $progressPercent
            .eq(activeIndex)
            .addClass('active')
            .text(bonusPercentage + '%');
    }
}

$(function () {
    var isExisting = $('.js-scheme-type').val() === 'EXISTING';
    if (!isExisting) {
        return;
    }
    var details = JSON.parse($('.js-existing-scheme-details').val());
    $('.existing-back-btn').addClass('d-none');
    $('.join-date').val(details.joinDate);
    $('.bonus-percentage').val(details.bonusPercentage);
    updateInvestmentProgress(details);
    populateSchemeDetails({
        schemeDetails: details
    });
    updateExistingDate({
        schemeDetails: details
    });
    $('.scheme-code').val(details.schemeCode);
    $('.scheme-type').val('EXISTING');
    var schemeName = $('#customer-scheme-Name').val().trim().toUpperCase();

    if (schemeName === 'NEW SWARNA SUBHIKSHAM') {
        var dueAmount = Number(details.dueAmount) || 0;

        $('.price-amount-input')
            .val(dueAmount)
            .prop('readonly', true)
            .trigger('input');
    }
    $('#passbookNo').val(details.passbookNo);
    $('.scheme-existing-left').removeClass('d-none');
    $('.scheme-registration-left').addClass('d-none');
    showStep(5);
});

$(document).on('click', '.saving-promo-code', function (e) {
    e.preventDefault();
    var $button = $(this);
    var mobileNo = $('.scheme-mobile').val();
    var promoCode = $.trim($('#customer-promocode').val());
    var promodata = {
        mobileNo: mobileNo,
        promoCode: promoCode
    };
    if (!promoCode) {
        $('.referral-message')
            .removeClass('text-success')
            .addClass('text-danger')
            .text('Please enter Promo Code.');
        return;
    }

    $.spinner().start();
    $.ajax({
        url: $button.data('url'),
        type: 'GET',
        data: promodata,
        success: function (response) {
            if (joinSchemeLogin.isLoggedOutResponse(response)) {
                window.location.reload();
                return;
            }
            if (response.success) {
                $('#customer-promocode').prop('readonly', true);

                $button.replaceWith(
                    '<span class="promocode-applied text-success">'
                    + '<i class="fa fa-check-circle"></i> '
                    + 'Applied (₹' + response.data.Amount + ')'
                    + '</span>'
                );
                $('.promo-amount').val(response.data.Amount);
            } else {
                $('.promo-message')
                    .removeClass('text-success')
                    .addClass('text-danger')
                    .text(response.message || response.data.Message);
            }
        },
        complete: function () {
            $.spinner().stop();
        }
    });
});

$(document).on('input', '.employee-referral-code', function (e) {
    e.preventDefault();
    var $this = $(this);
    var empRefCode = $.trim($this.val());
    var url = $this.data('url');
    var $message = $('.employee-referral-message');
    var $employeeNameField = $('.employee-name-field');
    var $employeeName = $('#employee-name');
    $message.text('').removeClass('text-success text-danger').addClass('d-none');
    $employeeName.val('');
    $employeeNameField.addClass('d-none');
    if (!empRefCode) {
        return;
    }

    var promodata = {
        empReferralCode: empRefCode
    };
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'GET',
        data: promodata,
        success: function (response) {
            if (joinSchemeLogin.isLoggedOutResponse(response)) {
                window.location.reload();
                return;
            }
            if (response.success) {
                $employeeName.val(response.data.ename || response.employeeName || '');
                $employeeNameField.removeClass('d-none');
            } else {
                // Show error message
                $message
                    .text(response.message || 'Invalid employee referral code.')
                    .removeClass('text-success d-none')
                    .addClass('text-danger');

                // Keep employee name hidden
                $employeeName.val('');
                $employeeNameField.addClass('d-none');
            }
        },

        error: function () {
            $message
                .text('Unable to verify employee referral code.')
                .removeClass('text-success d-none')
                .addClass('text-danger');

            $employeeName.val('');
            $employeeNameField.addClass('d-none');
        },

        complete: function () {
            $.spinner().stop();
        }
    });
});

initializeDatePicker(['.wedding-container', '.birthday-container']);
